import Vue from 'vue';
import Vuex, {
  CommitOptions,
  GetterTree,
  MutationTree, Store,
} from 'vuex';

Vue.use(Vuex);

export enum RootMutationTypes {
  SET_LOCALE = 'SET_LOCALE',
  SET_EDIT_MODE = 'SET_EDIT_MODE',
}

export enum RootGetterTypes {
  locale = 'locale',
  editMode = 'editMode',
  countryString = 'countryString',
}

export type RootState = {
  locale: string;
  editMode: boolean;
}

const state: RootState = {
  locale: 'en',
  editMode: false,
};

export type RootMutations<S = RootState> = {
  [RootMutationTypes.SET_LOCALE](rootState: S, locale: string): void;
  [RootMutationTypes.SET_EDIT_MODE](rootState: S, editMode: boolean): void;
}

const mutations: MutationTree<RootState> & RootMutations = {
  SET_EDIT_MODE (rootState, editMode) {
    rootState.editMode = editMode;
  },
  SET_LOCALE (rootState, locale) {
    rootState.locale = locale;
  },
};

export type RootGetters<S = RootState> = {
  [RootGetterTypes.editMode](rootState: S): boolean;
  [RootGetterTypes.locale](rootState: S): string;
  [RootGetterTypes.countryString](rootState: S): string;
}

const getters: GetterTree<RootState, RootState> & RootGetters = {
  editMode (rootState) {
    return rootState.editMode;
  },
  locale (rootState) {
    return rootState.locale;
  },
  countryString (rootState) {
    const country = rootState.locale === 'de' ? 'DE' : 'US';
    return `${rootState.locale}-${country}`;
  },
};

export type RootStore = Omit<
  Store<RootState>,
  'getters' | 'commit'
> & {
  commit<K extends keyof RootMutations, P extends Parameters<RootMutations[K]>[1]>(
    key: K,
    payload: P,
    options?: CommitOptions,
  ): ReturnType<RootMutations[K]>;
} & {
  getters: {
    [K in keyof RootGetters]: ReturnType<RootGetters[K]>
  };
}

const store: RootStore = new Vuex.Store({
  state,
  mutations,
  getters,
});

export default store;
